import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';
import { BusinessIntelligenceService } from 'src/app/services/business-intelligence/business-intelligence.service';
import { ManualOrderService } from 'src/app/services/manual-order/manual-order.service';

@Component({
  selector: 'app-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.scss']
})
export class EnterpriseComponent implements OnInit {


  catalog_nav = [
    // {
    //   'label': 'Video Production',
    //   'link': 'dji_production',
    //   'icon': 'https://www-cdn.djiits.com/dps/3b7953435e791d6a56253d87584e34cf.png'
    // },
    {
      'label': 'Enterprise',
      'link': 'enterprise',
      'icon': 'https://www-cdn.djiits.com/dps/77738ff32f7a228fc58b4f401261e481.png'
    },
    {
      'label': 'Agriculture',
      'link': 'agriculture',
      'icon': 'https://www-cdn.djiits.com/dps/5698cb42a9a1fdce69e22f30550d9767.png'
    },



  ]
  selected_item: any;
  active_nav: any;
  products: any;
  params: string;
  type: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: BusinessIntelligenceService,
    private webService: ManualOrderService,
    private serializer: UrlSerializer,
  ) { }


  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      console.log('hihi')
      window.scroll({
        top: 0,
        left: 0,

      });



    })


    this.route.queryParamMap.subscribe(queryParams => {
      this.type = queryParams.get("type")
      if (!this.type) {
        this.router.navigate(
          [],
          { queryParams: { type: 'enterprise' } }
        );
      }
      if (this.type) {
        this.params = this.serializer.serialize(this.router.createUrlTree([''],
          { queryParams: this.route.snapshot.queryParams }))
        this.getProduct()
      }

    })
  }


  async getProduct() {


    try {

      let response = await this.webService.getProduct(this.params + '&status=1')
      console.log(response)
      this.products = response.data

    } catch (e) {
      console.log(e)
    } finally {

    }
  }


  navigateTo(item) {
    this.router.navigate(
      [],
      { queryParams: { type: item.link } }
    );
    this.active_nav = item
  }

  selectItem(item) {
    this.selected_item = item
  }


}
